<template>
  <div :class="containerClass">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'ViewContainer',
  props: {
    containerClass: {
      type: String,
      default: 'h-[calc(100dvh-70px)] bg-light-100 dark:bg-dark-700 overflow-y-auto'
    }
  }
}
</script>
